import { FC } from "react";
import { Path, Svg } from "react-native-svg";
import { tSvgProps } from "../types";

const PdChevronRight: FC<tSvgProps> = (props) => (
  <Svg viewBox="0 0 4 7" fill="none" {...props}>
    <Path
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      focusable={false}
      d="m 4.0084738,3.5084746 -3.49999918,3.5 h -0.5 v -0.5 l 2.99999918,-3 -2.99999918,-3.00000002 v -0.5 h 0.5 z"
      fill="currentColor"
    />
  </Svg>
);

export default PdChevronRight;
